import { render, staticRenderFns } from "./ClientsOnEntryIcon.vue?vue&type=template&id=140a4df7&scoped=true"
import script from "./ClientsOnEntryIcon.vue?vue&type=script&lang=js"
export * from "./ClientsOnEntryIcon.vue?vue&type=script&lang=js"
import style0 from "./ClientsOnEntryIcon.vue?vue&type=style&index=0&id=140a4df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a4df7",
  null
  
)

export default component.exports